import {USER_DATA_REQUEST, USER_DATA_SUCCESS, USER_DATA_FAILURE} from '../constants';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const userDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_DATA_REQUEST:
      return { ...state, loading: true, error: null };
    case USER_DATA_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case USER_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default userDataReducer;